<template>
  <Layout class="layout" :class="userInfo.tenantCode === 'ADMIN' ? 'backStage' : ''">
    <Header class="header">
      <div class="logo"></div>
      <div class="info">
        <!-- <Icon size="20" type="md-unlock" @click="handleChangePW" /> -->
        <span class="notice">{{ notice }}</span>
        <span class="down" @click.stop="handleHelpCenter">帮助中心</span>
        <span class="down down-border" @click.stop="handleDownLoad">下载中心</span>
        <Badge :count="notReadNum" overflow-count="9" :offset="[18, -4]">
          <span class="down down-border" @click.stop="handleUpdateLog">更新日志</span>
        </Badge>
        <span class="name">您好，{{ userInfo.name }}</span>
        <Poptip placement="bottom-end">
            <Icon class="user-more" size="20" type="ios-more" />
            <div slot="content">
              <div class="more-item" @click="handleChangePW">修改密码</div>
              <div class="more-item" @click="handleLogout">退出登录</div>
            </div>
        </Poptip>
      </div>
    </Header>
    <Layout>
      <Sider
        ref="slider"
        :style="{ background: '#fff' }"
        :collapsed-width="0"
        collapsible
        v-model="toggle"
        class="layout-left"
      >
        <div class="toggle-icon" @click="handleToggle" :class="toggle ? 'active' : ''"><Icon type="ios-arrow-back" /></div>
        <Menu
          ref="menu"
          :active-name="activeName"
          theme="light"
          width="auto"
          accordion
          :open-names="defalutOpen"
          @on-select="handleSelect"
        >
          <MyMenuItem :menus="menusList" />
        </Menu>
      </Sider>
      <div class="content">
        <TagList />
        <div class="view">
          <keep-alive>
            <router-view :notice="notice" v-if="$route.meta.keepAlive" @readUpdateLog="getUpdateLogNumOfNotRead"></router-view>
          </keep-alive>
          <router-view :notice="notice" v-if="!$route.meta.keepAlive" @readUpdateLog="getUpdateLogNumOfNotRead"></router-view>
        </div>
      </div>
    </Layout>
    <Watermark />
    <ChangePassword ref="changePassword" v-if="changePasswordVisible" />
  </Layout>
</template>

<script>
import MyMenuItem from './MyMenuItem.vue'
import Watermark from './Watermark.vue'
import ChangePassword from './ChangePassword.vue'
import TagList from './TagList.vue'
import { noticeHead, getUpdateLogNumOfNotRead } from '@/api/publicApi'
export default {
  name: 'srm-layout',
  components: { MyMenuItem, Watermark, ChangePassword, TagList },
  props: {
    msg: String,
  },
  data() {
    return {
      changePasswordVisible: false,
      defalutOpen: [],
      toggle: false,
      activeName: '',
      notice: '',
      notReadNum: 0,
    }
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile
    },
    menusList() {
      let menu = [
        {
          name: '首页',
          parentId: '0',
          type: 1,
          id: '00000',
          url: '/home',
          childResourceList: [],
        },
        ...this.$store.getters.menusList,
      ]
      if (this.$bp.includes('srm:workbench:detail')) {
        menu = [
          {
            name: '工作台',
            parentId: '0',
            type: 1,
            id: '00000',
            url: '/workbench',
            childResourceList: [],
          },
          ...this.$store.getters.menusList,
        ]
      }
      return menu
    },
    userInfo() {
      return this.$store.getters.userInfo || {}
    },
  },
  watch: {
    $route: {
      handler(val) {
        this.initMenuActive()
      },
      immediate: true,
    },
    isMobile: {
      handler(val) {
        this.toggle = val
      },
      immediate: true
    }
  },
  mounted() {
    this.initMenuActive()
    this.noticeHead()
    this.getUpdateLogNumOfNotRead()
  },
  methods: {
    async noticeHead() {
      const res = await noticeHead()
      if (res) {
        this.notice = res
      } else {
        this.notice = ''
      }
    },
    async getUpdateLogNumOfNotRead() {
      const res = await getUpdateLogNumOfNotRead()
      if (res) {
        this.notReadNum = res
      } else {
        this.notReadNum = 0
      }
    },
    handleDownLoad() {
      this.$router.push('/downloadCenter')
    },
    handleHelpCenter() {
      this.$router.push('/helpCenter')
    },
    handleUpdateLog() {
      this.$router.push('/updateLog')
    },
    handleToggle() {
      this.toggle = !this.toggle
    },
    initMenuActive() {
      this.$nextTick(() => {
        let pathname = window.location.pathname
        let findActive = (list) => {
          let active = null
          let backObj = {}
          // 递归找出当前路由的对象
          let _find = (list) => {
            for (let i = 0; i < list.length; i++) {
              if (active) {
                break
              }
              // 设置回溯对象
              backObj[list[i].parentId] = list[i].id
              if (
                pathname === list[i].url ||
                (list[i].url && pathname.indexOf(list[i].url + '/') > -1)
              ) {
                active = list[i]
                break
              }
              if (
                list[i].childResourceList &&
                list[i].childResourceList.length
              ) {
                _find(list[i].childResourceList)
              }
            }
          }
          _find(list)
          defalutIndexArr = []
          // 回溯找到链路
          let _back = (obj, id) => {
            for (let i in obj) {
              if (obj[i] === id) {
                defalutIndexArr.push(obj[i])
                _back(obj, i)
              }
            }
          }
          if (active) {
            _back(backObj, active.id)
          }
          // 删除一位
          defalutIndexArr.shift()
          return {
            active,
            defalutIndexArr,
          }
        }
        let { active, defalutIndexArr } = findActive(this.menusList)
        this.defalutOpen = defalutIndexArr
        this.activeName = active?.id
        setTimeout(() => {
          this.$refs.menu.updateOpened()
        }, 100)
      })
    },
    handleChangePW() {
      if (this.changePasswordVisible) {
        this.$refs.changePassword.visible = true
      } else {
        this.changePasswordVisible = true
      }
    },
    handleSelect(data) {
      let findUrl = function (list) {
        let url = null
        let _find = function (list) {
          for (let i = 0; i < list.length; i++) {
            if (url) {
              break
            }
            if (list[i].id === data) {
              url = list[i].url
              break
            }
            if (list[i].childResourceList && list[i].childResourceList.length) {
              _find(list[i].childResourceList)
            }
          }
        }
        _find(list)
        return url
      }
      let url = findUrl(this.menusList)
      if (url) {
        this.$router.push(url)
      }
    },
    handleLogout() {
      this.$store.dispatch('logout')
    },
  },
}
</script>

<style lang="less" scoped>
.layout {
  height: 100vh;
  background-color: #f5f7f9;
}

.content {
  margin-top: 15px;
  width: ~'calc(100% - 15px)';
  overflow: hidden;
  .view {
    height: ~'calc(100% - 47px)';
    margin-left: 15px;
    padding-right: 15px;
    overflow: auto;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 4px 10px 0px rgba(78, 89, 105, 0.06);
  background-color: #fff;
  position: relative;
  z-index: 999;
  padding-left: 64px;
  padding-right: 30px;
  height: 60px;
}

.logout {
  color: #0a1931;
  cursor: pointer;
}

.logo {
  width: 80px;
  height: 32px;
  background-image: url('@/assets/img/logo.png');
  background-repeat: no-repeat;
  background-size: 100%;
}

.info {
  .name {
    font-size: 14px;
    margin: 0 16px;
    border-left: 1px solid #ddd;
    padding-left: 16px;
  }
  .down {
    padding-left: 16px;
    margin-left: 16px;
    font-size: 14px;
    cursor: pointer;
    user-select: none;
  }
  .down-border {
    border-left: 1px solid #ddd;
  }
  i {
    cursor: pointer;
  }
}
.layout {
  .ivu-menu-vertical.ivu-menu-light:after {
    display: none;
  }
}

.layout {
  /deep/ .ivu-layout-sider-trigger{
    display: none;
    background: linear-gradient(135deg, #7EF9CB 0%, #1DD0DA 42%, #06B2E5 71%, #0197F1 100%);
  }
  /deep/ .ivu-layout-sider-zero-width-trigger {
    display: none !important;
    background: linear-gradient(135deg, #7EF9CB 0%, #1DD0DA 42%, #06B2E5 71%, #0197F1 100%);
    z-index: 999;
  }
  /deep/.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
    background: linear-gradient(
      135deg,
      #7ef9cb 0%,
      #1dd0da 42%,
      #06b2e5 71%,
      #0197f1 100%
    );
    color: #fff;
    &::after {
      display: none;
    }
  }
  /deep/.ivu-ivu-menu-item,
  /deep/.ivu-menu-submenu-title {
    display: flex;
    align-items: center;
    span {
      margin-right: 4px;
    }
  }
  /deep/.ivu-layout-sider {
    transition: inherit;
  }
}
/deep/.ivu-layout {
  height: ~'calc(100% - 60px)';
}
.toggle-icon {
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  background-color: #fff;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  cursor: pointer;
  font-size: 16px;
  &.active {
    transform: rotate(180deg);
  }
}
.user-more {
  transform: rotate(90deg);
}
.more-item {
  padding: 8px 0;
  text-align: center;
  cursor: pointer;
  border-bottom: 1px solid #e8eaec;
  color: #515a6e;
}
.info {
  /deep/.ivu-badge-count {
    height: 16px;
    min-width: 16px;
    line-height: 13px;
    padding: 0 3px;
  }
  .more-item:last-child {
    border-bottom: none;
  }
}
.notice {
  font-size: 16px;
  color: #ff0000;
  position: relative;
  top: 1px;
}
.backStage {
  .header {
    background: linear-gradient(
      135deg,
      #7ef9cb 0%,
      #1dd0da 42%,
      #06b2e5 71%,
      #0197f1 100%
    );
    color: #fff;
  }
}
</style>
